<template>
  <div class="main-chart">
    <el-row>
      <el-col class="chart-header">
        <el-select
          v-model="opcOpportunitie"
          class="graphics"
          @change="calculateLeads()">
          <el-option
            v-for="(lead, index) in arrOpportunities"
            :key="index"
            :label="lead.label"
            :value="lead.value"/>
        </el-select>
        <p>El seguimiento neto muestra el número de nuevas oportunidades menos el número de oportunidades cerradas.</p>
        <el-select
          v-model="opcPeriod"
          class="filter"
          @change="calculateLeads()">
          <el-option
            v-for="(filter, index) in arrPeriod"
            :key="index"
            :label="filter.label"
            :value="filter.value"/>
        </el-select>
      </el-col>
      <el-col
        :span="18"
        class="chart-content">
        <div>
          <line-chart
            :datasets="dataChartData"
            :labels="dataChartLabels"
          />
        </div>
      </el-col>
      <el-col
        v-if="profile.role === 'superadmin'"
        :span="6"
        class="create-leads">
        <h5>¿Quieres crear más oportunidades?</h5>
        <p>Crea una campaña para crear más oportunidades y asi poder tener un mayor alcance.</p>
        <div class="add">
          <el-button @click="addCampaign">
            Crear Campaña
          </el-button>
        </div>
      </el-col>
      <el-col
        v-else
        :span="6"
        class="create-leads">
        <h5>¿Que se muestra en la gráfica?</h5>
        <p>Esta información es de acuerdo al estado en el que se encuentran las oportunidades, ya sea cerradas o no.</p>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import http from '@/services/http.service'
import moment from 'moment'
import LineChart from '@/components/_shared/charts/line-chart'

export default {
  name: 'DashboardChartLine',
  components: {
    LineChart
  },
  props: {
    year: {
      type: String,
      default: moment().format('YYYY')
    },
    profile: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      opcPeriod: 1,
      arrPeriod: [
        {
          label: 'Último mes',
          value: 1
        },
        {
          label: 'Últimos 3 meses',
          value: 3
        },
        {
          label: 'Últimos 6 meses',
          value: 6
        },
        {
          label: 'Últimos 9 meses',
          value: 9
        },
        {
          label: 'Últimos 12 meses',
          value: 12
        }
      ],
      opcOpportunitie: 'Aceptada',
      arrOpportunities: [
        {
          label: 'Oportunidades cerradas',
          value: 'Aceptada'
        },
        {
          label: 'Oportunidades en proceso',
          value: 'En Proceso'
        },
        {
          label: 'Oportunidades rechazados',
          value: 'Rechazada'
        }
      ]
    }
  },
  computed: {
    dataChartLabels () {
      return this.$store.getters['dash/chartLabels']
    },
    dataChartData () {
      return this.$store.getters['dash/chartData']
    },
    day () {
      return moment().format('DD')
    },
    month () {
      return moment().format('MM')
    }
  },
  watch: {
    year: function (newYear, oldYear) {
      this.calculateLeads()
    }
  },
  mounted () {
    this.calculateLeads()
  },
  methods: {
    addCampaign () {
      this.$emit('addCampaign')
    },
    calculateLeads () {
      let _today = `${this.year}-${this.month}-${this.day}`
      let _todayFormatted = moment(`${this.year}-${this.month}-${this.day}`).format('MMMM-YY')
      let _monthToday = moment(_today).format('M')
      let _startDate = moment(_today).subtract(this.opcPeriod, 'months').format('YYYY-MM-DD')
      let _values = []
      _values[0] = { monthLabel: _todayFormatted, month: _monthToday }
      for (let _i = 1; _i < this.opcPeriod + 1; _i++) {
        _values[_i] = { monthLabel: moment(_today).subtract(_i, 'months').format('MMMM-YY'),
          month: moment(_today).subtract(_i, 'months').format('M') }
      }
      this.consultLeads(_today, _startDate, _values)
    },
    consultLeads (_today, _startDate, _arrValues) {
      http.get(`dashboard/leads?startDate=${_startDate}&endDate=${_today}`)
        .then(({data}) => {
          this.dataOpportunities = data
          for (let _a = 0; _a < _arrValues.length; _a++) {
            _arrValues[_a].total = 0
            for (let item of data) {
              if (item.status === this.opcOpportunitie && parseInt(item.month) === parseInt(_arrValues[_a].month)) {
                _arrValues[_a].total = item.total
              }
            }
          }
          let _data = _arrValues.reverse()
          let _datalabelMonth = []
          let _dataTotal = []
          _data.forEach((item) => {
            _datalabelMonth.push(item.monthLabel)
            _dataTotal.push(item.total)
          })
          this.$store.dispatch('dash/calculatePeriod', { chartData: _dataTotal, chartLabels: _datalabelMonth })
        })
    }
  }
}
</script>

<style scoped lang="scss">
  .main-chart{
    margin-top: 30px;
    border-radius: 3px;
    background-color: #ffffff;
    .chart-header{
      height: 70px;
      background-color: #EFEFEF;
      position: relative;
      border: 1px solid #E5E5E5;
      p{
        margin: 0 15px;
        @include font-primary(12px, regular);
        color: $items-primary;
      }
    }
    .chart-content{
      height: 300px;
      padding:0 30px;
      border-left: 1px solid #E5E5E5;
      border-bottom: 1px solid #E5E5E5;
    }
    .create-leads{
      height: 300px;
      padding: 30px;
      position: relative;
      border-right: 1px solid #E5E5E5;
      border-bottom: 1px solid #E5E5E5;
      border-left: 1px solid #E5E5E5;
      h5{
        @include font-lato(14px, bold);
        color: $header-tabs-active;
      }
      p{
        @include font-primary(12px, regular);
        color: $header-tabs-active;
      }
      .add{
        margin: 80px auto;
        bottom: 15px;
        left: 0;
        .el-button{
          background-color: $primary;
          color: #ffffff;
          width: 100%;
          margin: 0 auto;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/modules/dashboard/dashboard-chart-line.vue